import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";

export const setInspectionForm = (data, save=0) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.maintenance.setInspectionForm+`?save=${save}`
    ); 
    if (res?.data?.response?.status == true) {
        return true;
    } else {
        return false;
    }
}

export const viewInspectionForm = (request_id) => async (
    dispatch
  ) => {
    const res = await callWebService(
      callTypes.get,
      '',
      Config.maintenance.getInspectionForm+"?request_id="+request_id
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: "INSPECTION_FORM",
        payload: data.response.data,
      });
      return true;
    }
  };

export const sendInspectionMail = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.maintenance.sendInspectionMail
  ); 
  if (res?.data?.response?.status === true) {
      return true;
  } else {
      return false;
  }
}

export const getInspectionForm = (request_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.maintenance.sendInspectionForm+"?request_id="+request_id
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: "INSPECTION_FORM_DATA",
      payload: data.response.data,
    });
    return true;
  }
}